import {BufferWriter, Writer} from "protobufjs";

import {Entry, EntryCountByProject} from "../../../domain/model/entry";
import {IEntryRepository} from "../../../domain/repository/entry_repository";

import {common, entity, api} from "../rpc/api";
import {getToken} from "./bind_token";
import {IApiClient} from "../client";

import EntryList = entity.EntryList;
import ProjectID = entity.ProjectID;
import ProjectIDList = entity.ProjectIDList;
import EntryCountByProjectList = api.EntryCountByProjectList;
import Count = common.Count;

import {
    EntryConvertResponse,
    EntryConvertResponseList
} from "./entry_api_convert";

class EntryAPI implements IEntryRepository {
    constructor(readonly apiClient: IApiClient){
    }

    public getAllByProject(projectID: string): Promise<Entry[]>{
        return new Promise<Entry[]>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: ProjectID = new ProjectID();
                    req.id = projectID;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.EntryService/GetAllByProject", token, ProjectID.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: EntryList = EntryList.decode(binary);
                    // BE=>FE 型変換
                    const resConverted: EntryConvertResponseList = EntryConvertResponseList.from(res);
                    const items: Entry[] = resConverted.items.map((item: EntryConvertResponse): Entry => {
                        return Entry.from(item);
                    });
                    resolve(items);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

    public getCountByProject(projectID: string): Promise<number|Long> {
        return new Promise<number|Long>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: ProjectID = new ProjectID();
                    req.id = projectID;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.EntryService/GetCountByProject", token, ProjectID.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: Count = Count.decode(binary);
                    const item: number|Long = res.count;
                    resolve(item)
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

    public getCountByProjects(ids: string[]): Promise<EntryCountByProject[]> {
        return new Promise<EntryCountByProject[]>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: ProjectIDList = new ProjectIDList();
                    req.ids = ids;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.EntryService/GetCountByProjects", token, ProjectIDList.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: EntryCountByProjectList = EntryCountByProjectList.decode(binary);
                    const items: EntryCountByProject[] = res.items.map((item: api.EntryCountByProject): EntryCountByProject => {
                        return EntryCountByProject.from(item);
                    });
                    resolve(items);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

    public create(projectID: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: ProjectID = new ProjectID();
                    req.id = projectID;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.EntryService/Create", token, ProjectID.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    resolve()
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

    public delete(projectID: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: ProjectID = new ProjectID();
                    req.id = projectID;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.EntryService/Delete", token, ProjectID.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    resolve()
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }
}

const createEntryAPI = (apiClient: IApiClient): IEntryRepository => {
    return new EntryAPI(apiClient);
};

export {createEntryAPI};



// WEBPACK FOOTER //
// ./src/infra/api/service/entry_api.ts